import { ModuleConfig } from '@core/interfaces';

const config: ModuleConfig = {
  name: 'Busk',
  baseUrl: '',
  routes: [
    {
      path: '/admin/busk/stock',
      page: 'BuskStock',
      title: 'Busk Admin warehouse',
      exact: true
    }
  ],
  requireAuthenticated: true
};

export default config;
